export function fmtTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return "";
  }
}

/**
 * CANONICAL local-date helpers — use these EVERYWHERE you need to convert
 * between a Date/ISO and a YYYY-MM-DD date string. Never use
 * `Date.toISOString().slice(0,10)` — that returns the UTC date, which is
 * off by one day near midnight for non-UTC users (root cause of the
 * "click Friday → opens Thursday" bug).
 *
 *   localYmd(date)      → "YYYY-MM-DD" in the device's local timezone
 *   eventLocalYmd(iso)  → "YYYY-MM-DD" of an event's local-display date
 */
export function localYmd(d) {
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
export function eventLocalYmd(iso) {
  if (!iso) return "";
  return localYmd(new Date(iso));
}
/** Build a Date at LOCAL midnight from a "YYYY-MM-DD" key. */
export function ymdToLocalDate(ymd) {
  if (!ymd) return null;
  const [y, m, d] = ymd.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  } catch {
    return "";
  }
}

export function fmtMonth(ym) {
  // ym = "YYYY-MM" → "May 2026"
  if (!ym || ym.length < 7) return ym || "";
  try {
    const [y, m] = ym.split("-").map(Number);
    return new Date(y, m - 1, 1).toLocaleDateString(undefined, {
      month: "long", year: "numeric",
    });
  } catch {
    return ym;
  }
}

export function fmtRelativeDate(iso) {
  if (!iso) return "";
  try {
    const todayKey = localYmd(new Date());
    const tomorrow = new Date(); tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowKey = localYmd(tomorrow);
    const itemKey = localYmd(new Date(iso));
    if (itemKey === todayKey) {
      // For today, prefer "Today HH:MM" so it's distinguishable from undated.
      return `Today ${fmtTime(iso)}`.trim();
    }
    if (itemKey === tomorrowKey) {
      return `Tomorrow ${fmtTime(iso)}`.trim();
    }
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
  } catch {
    return "";
  }
}

export function fmtFromNow(iso) {
  if (!iso) return "";
  const diff = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(diff);
  const min = Math.round(abs / 60000);
  if (min < 1) return "now";
  if (min < 60) return `${min}m`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h}h`;
  const d = Math.round(h / 24);
  return `${d}d`;
}

export function groupByDay(events) {
  const groups = {};
  for (const e of events) {
    const day = eventLocalYmd(e.start_at);
    (groups[day] = groups[day] || []).push(e);
  }
  return Object.entries(groups).sort(([a], [b]) => a.localeCompare(b));
}

export function memberColor(persons, id) {
  return persons.find((p) => p.id === id)?.color || "#8FA28F";
}
